exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".daySwitcher[data-v-2d6b87e4]{font-family:Open Sans,sans-serif;font-weight:700;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;font-size:14px;background-color:#242c58;padding:5px 6px;color:#fafafb}.daySwitcher .buttonLeft[data-v-2d6b87e4]{cursor:pointer;padding-right:5px}.daySwitcher .buttonRight[data-v-2d6b87e4]{cursor:pointer;padding-left:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2d6b87e4","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/catalog/card/components/tabs/schedule/components/schedulecalendar/DaySwitcher.vue
// module id = 9f2c14fb27f08c020d8f
// module chunks = 6